<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/24/outline'
import type { CheckboxRootEmits, CheckboxRootProps } from 'radix-vue'
import { CheckboxIndicator, CheckboxRoot, useEmitAsProps } from 'radix-vue'
import { cn } from '../../utils'

const props = defineProps<CheckboxRootProps>()
const emits = defineEmits<CheckboxRootEmits>()

const emitsAsProps = useEmitAsProps(emits)
</script>

<template>
    <CheckboxRoot
        v-bind="{ ...props, ...emitsAsProps }"
        :class="
            cn(
                'peer size-4 shrink-0 rounded-sm border border-gray-300',
                'focus:ring-primary-800 focus:ring-2 focus:ring-offset-2',
                'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                'disabled:cursor-not-allowed disabled:opacity-50',
                'data-[state=checked]:bg-primary-800 data-[state=checked]:text-white data-[state=checked]:border-primary-900',
                $attrs.class ?? ''
            )
        "
    >
        <CheckboxIndicator class="text-current flex items-center justify-center">
            <CheckIcon class="size-3.5" />
        </CheckboxIndicator>
    </CheckboxRoot>
</template>
